import React from 'react';
import moment from 'moment';
import { Table } from 'antd';
import { TopAnchor } from '../../types';

const { Column } = Table;

type Props = {
	topAnchors: TopAnchor[];
};

export default function TopAnchorsTable({ topAnchors }: Props) {
	const dataSource = topAnchors.map((topAnchor, index) => ({ ...topAnchor, key: index + 1 }));

	return (
		<Table dataSource={dataSource} pagination={false} size="small" data-cy="top-anchors-table">
			<Column title="#" dataIndex="key" align="left" />
			<Column className="no-wrap" title="Anchor Text" dataIndex="anchor" />
			<Column
				className="no-wrap al-left"
				title="Domains"
				dataIndex="domains_num"
				render={(_, record: TopAnchor) => parseInt(record['domains_num']).toLocaleString()}
			/>
			<Column
				className="no-wrap al-right"
				title="Backlinks"
				dataIndex="backlinks_num"
				render={(_, record: TopAnchor) => parseInt(record['backlinks_num']).toLocaleString()}
			/>
			<Column
				className="no-wrap al-right"
				title="First Seen"
				dataIndex="first_seen"
				render={(_, record: TopAnchor) => moment.unix(parseInt(record['first_seen'])).format('MMM DD, YYYY')}
			/>
			<Column
				className="no-wrap al-right"
				title="Last Seen"
				dataIndex="last_seen"
				render={(_, record: TopAnchor) => moment.unix(parseInt(record['last_seen'])).format('MMM DD, YYYY')}
			/>
		</Table>
	);
}
